import { api } from "./configs/axiosConfigs"

export const RenditionSpentAPI = {
    getRenditionSpents: async (idcompany: number, data?: any) => {
        const response = await api.get(
        '/reportSpent',
        {
            params: {
                ...data,
                idcompany
            }
        }
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    create: async (data: any) => {
        const response = await api.post(
            '/reportSpent/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    edit: async (id: number, data: any) => {
        const response = await api.post(
        `/reportSpent/update/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    delete: async (id: number, idcompany: number) => {
        const response = await api.delete(
        `/reportSpent/${id}`,
        {
            params: {
                idcompany
            }
        }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    }
}